import React, { useState } from 'react';




const FAQ = () => {

    const [expanded, setExpanded] = useState(false);
  return (

    
<section class="bg-white dark:bg-gray-900 py-24 top-8">
  <div class="py-8 px-4 mx-auto max-w-screen-xl sm:py-16 lg:px-6 py-12 top-4">
  <div className='max-w-[1400px]   border-b-2 border-gray-600 py-5 px-4 content-center'>

      <h2 class="mb-8 text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white">FAQ - Frequently asked questions</h2>
      <div class="grid pt-8 text-left border-t border-gray-200 md:gap-16 dark:border-gray-700 md:grid-cols-2">
          <div>
          <div className="mb-10">
                <h3 className="flex items-center justify-between mb-4 text-lg font-medium text-gray-900 dark:text-white">
                  <span>PERGUNTA 1?</span>
                  <button onClick={() => setExpanded(!expanded)} className="focus:outline-none">
                    <svg className={`w-5 h-5 transition-transform transform ${expanded ? 'rotate-180' : ''}`} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"></path></svg>
                  </button>
                </h3>
                {expanded && (
                  <p className="text-gray-500 dark:text-gray-400">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat.</p>
                )}
              </div>

              <div className="mb-10">
                <h3 className="flex items-center justify-between mb-4 text-lg font-medium text-gray-900 dark:text-white">
                  <span>PERGUNTA 2?</span>
                  <button onClick={() => setExpanded(!expanded)} className="focus:outline-none">
                    <svg className={`w-5 h-5 transition-transform transform ${expanded ? 'rotate-180' : ''}`} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"></path></svg>
                  </button>
                </h3>
                {expanded && (
                  <p className="text-gray-500 dark:text-gray-400">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat.</p>
                )}
              </div>
          </div>
          <div>
          <div className="mb-10">
                <h3 className="flex items-center justify-between mb-4 text-lg font-medium text-gray-900 dark:text-white">
                  <span>PERGUNTA 3?</span>
                  <button onClick={() => setExpanded(!expanded)} className="focus:outline-none">
                    <svg className={`w-5 h-5 transition-transform transform ${expanded ? 'rotate-180' : ''}`} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"></path></svg>
                  </button>
                </h3>
                {expanded && (
                  <p className="text-gray-500 dark:text-gray-400">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat.</p>
                )}
              </div>
              <div className="mb-10">
                <h3 className="flex items-center justify-between mb-4 text-lg font-medium text-gray-900 dark:text-white">
                  <span>PERGUNTA 4?</span>
                  <button onClick={() => setExpanded(!expanded)} className="focus:outline-none">
                    <svg className={`w-5 h-5 transition-transform transform ${expanded ? 'rotate-180' : ''}`} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"></path></svg>
                  </button>
                </h3>
                {expanded && (
                  <p className="text-gray-500 dark:text-gray-400">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat.</p>
                )}
              </div>

          </div>
      </div>
      </div>
  </div>
</section>
  );
};

export default FAQ;
